import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import reportAction from "../../../store/actions/reportCampaignAction";
import linkTypeCampaigns from "../campaigns/linkTypeCampaigns";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";
import typeCampaignCategorySelected from "./TypeCampaignCategorySelected";
import SeparationActive from "./SeparationActive";

const HeaderReport = ({
  dateFrom,
  dateTo,
  eventDataChart,
  whichSeparationActive,
  setTypeSeparationDataChart,
  getCampaignReportWithCampaignName,
  getCampaignsReportWithCampaignType,
  getCampaignsDataChartWithCampaignName,
  getCampaignsDataChartWithCampaignType,
  getCampaignsDataSeparationWithCampaignName,
  getCampaignsDataSeparationWithCampaignType,
  userPermission,
  resetIsGetDataBrowserFromApi,
}) => {
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    getAllCampaignsUser();
  }, []);

  const getAllCampaignsUser = async () => {
    const campaignsUser = await sendRequestGetAllCampaignsUser();
    setCampaigns(campaignsUser);
  };

  const clickCampaignNameHandler = (e, campaignID) => {
    changeNameItemReport(e.currentTarget.textContent);
    const parentCollapsedTag = document.querySelector(
      "#" + e.currentTarget.parentNode.parentNode.id
    );
    parentCollapsedTag.classList.add("show");
    removeLastBgPrimaryClassTag();
    addClassBgPrimaryToTag(e);
    closeDropDownSelectCampaign();
    resetIsGetDataBrowserFromApi();
    getCampaignReportWithCampaignName({
      campaign_id: campaignID,
      date_from: dateFrom,
      date_to: dateTo,
    });
    getCampaignsDataChartWithCampaignName({
      campaign_id: campaignID,
      date_from: dateFrom,
      date_to: dateTo,
      event_data_chart: eventDataChart,
    });

    let separationNow = whichSeparationActive;
    if (whichSeparationActive == SeparationActive.CAMPAIGN) {
      separationNow = SeparationActive.PUBLISHER;
      setTypeSeparationDataChart({
        separation: separationNow,
      });
    }

    getCampaignsDataSeparationWithCampaignName({
      campaign_id: campaignID,
      separation: separationNow,
      date_from: dateFrom,
      date_to: dateTo,
    });
  };

  const changeNameItemReport = (nameItemReport) => {
    document.querySelector("#name-item-report").textContent = nameItemReport;
  };

  const removeLastBgPrimaryClassTag = () => {
    document
      .querySelector(".drop-down-select-campaign .bg-success")
      .classList.remove("bg-success");
  };

  const addClassBgPrimaryToTag = (e) => {
    e.currentTarget.classList.add("bg-success");
  };

  const sendRequestGetAllCampaignsUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let campaignsUser;
    try {
      campaignsUser = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/campaign/report",
        headersRequest
      );
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return campaignsUser.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const dropDownSelectCampaign = (e) => {
    if (
      document
        .querySelector(
          "#container-dropdown-select-campaign-report div.dropdown"
        )
        .classList.contains("show")
    ) {
      return;
    }

    document
      .querySelector("#container-dropdown-select-campaign-report div.dropdown")
      .classList.add("show");
    document
      .querySelector(
        "#container-dropdown-select-campaign-report div.drop-down-select-campaign"
      )
      .classList.add("show");
  };

  const closeDropDownSelectCampaign = () => {
    document
      .querySelector(".dropdown-menu.drop-down-select-campaign")
      .classList.remove("show");
  };

  const headerAccordionClickHandler = (e) => {
    dropDownSelectCampaign();
    const tagIconID =
      "#header-" +
      e.currentTarget.attributes["data-header"].nodeValue +
      "-accordion-icon";
    const tagIcon = document.querySelector(tagIconID);
    const classTagIcon = tagIcon.classList[1];
    if (classTagIcon == "fa-angle-left") {
      tagIcon.classList.remove("fa-angle-left");
      tagIcon.classList.add("fa-angle-down");
    } else if (classTagIcon == "fa-angle-down") {
      tagIcon.classList.remove("fa-angle-down");
      tagIcon.classList.add("fa-angle-left");
    }
  };

  const clickCampaignsHandler = (e, campaignType) => {
    removeLastBgPrimaryClassTag();
    resetIsGetDataBrowserFromApi();
    addClassBgPrimaryToTag(e);
    changeNameItemReport(e.currentTarget.textContent);
    getCampaignsReportWithCampaignType({
      campaign_type: campaignType,
      date_from: dateFrom,
      date_to: dateTo,
    });
    getCampaignsDataChartWithCampaignType({
      campaign_type: campaignType,
      date_from: dateFrom,
      date_to: dateTo,
      event_data_chart: eventDataChart,
    });

    setTypeSeparationDataChart({
      separation: SeparationActive.CAMPAIGN,
    });

    getCampaignsDataSeparationWithCampaignType({
      campaign_type: campaignType,
      date_from: dateFrom,
      date_to: dateTo,
      separation: SeparationActive.CAMPAIGN,
    });
  };

  return (
    <div
      id="name-campaigns"
      className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-1"
    >
      <div className="p-2 d-flex align-items-center justify-content-between">
        <span id="name-item-report" className="text-dark">
          کمپین های شما
        </span>
        <span id="container-dropdown-select-campaign-report">
          <div className="dropdown ">
            <button
              className="btn dropdown-toggle text-dark"
              type="button"
              id="drop-down-button-select-campaign"
              data-toggle="dropdown"
              aria-haspopup="false"
              aria-expanded="false"
            >
              همه کمپین ها
            </button>
            <div
              className="dropdown-menu drop-down-select-campaign py-0 my-0 border-success border-bottom-0"
              style={{ width: "300px" }}
              aria-labelledby="drop-down-button-select-campaign"
            >
              <div className="d-flex flex-column border-radius-drop-down-select-campaign">
                <span
                  className="py-2 pr-2 bg-success border-success border-bottom text-right hover border-radius-top-drop-down-select-campaign "
                  onClick={(e) => {
                    clickCampaignsHandler(e, typeCampaignCategorySelected.ALL);
                  }}
                >
                  <span className="text-dark text-right">همه کمپین ها</span>
                </span>
                {/* <span
                  className="py-2 pr-2 border-success border-bottom text-right hover"
                  onClick={(e) => {
                    clickCampaignsHandler(
                      e,
                      typeCampaignCategorySelected.BANNER
                    );
                  }}
                >
                  <span className="text-dark ">همه کمپین ها بنری</span>
                </span> */}

                <span className="accordion-menu border-radius-bottom-drop-down-select-campaign">
                  <div
                    className="accordion "
                    id="accordion-all-campaign-banner"
                    onClick={headerAccordionClickHandler}
                    data-header="banner"
                    data-toggle="collapse"
                    data-target="#accordion-body-all-campaign-banner"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <div className="card shadow-none">
                      <div className="card-header pr-2 py-2 m-0 border-success rounded-0">
                        <div className="mb-0">
                          <div className=" d-flex hover  justify-content-between ">
                            <span className="text-dark text-right">
                              {" "}
                              کمپین های بنری
                            </span>
                            <span>
                              <i
                                id="header-banner-accordion-icon"
                                className="fa fa-angle-left"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div
                        id="accordion-body-all-campaign-banner"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion-all-campaign-banner"
                      >
                        <div className="card-body p-0 ">
                          {campaigns.map((campaign) => {
                            if (
                              campaign.type ==
                              linkTypeCampaigns.typeCampaignName.BANNER_SIMPLE
                            ) {
                              return (
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    clickCampaignNameHandler(e, campaign.id);
                                  }}
                                  className="py-2 pr-2 text-right hover border-success border-bottom"
                                >
                                  <span className="text-dark  ">
                                    {campaign.name}
                                  </span>
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                  {userPermission.includes("view-all-banners-users") && (
                    <div
                      className="accordion hover"
                      id="accordion-all-campaign-banner-alternative"
                      onClick={headerAccordionClickHandler}
                      data-header="native"
                      data-toggle="collapse"
                      data-target="#accordion-body-all-campaign-banner-alternative"
                      aria-expanded="true"
                      aria-controls="accordion-body-all-campaign-banner-alternative"
                    >
                      <div className="card shadow-none">
                        <div className="card-header pr-2 py-2 m-0 border-success rounded-0">
                          <div className="mb-0">
                            <div className=" d-flex  hover justify-content-between ">
                              <span className="text-dark text-right">
                                {" "}
                                کمپین های بنری جایگزین
                              </span>
                              <span>
                                <i
                                  id="header-native-accordion-icon"
                                  className=" fa fa fa-angle-left"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div
                          id="accordion-body-all-campaign-banner-alternative"
                          className="collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion-all-campaign-banner-alternative"
                        >
                          <div className="card-body p-0">
                            {campaigns.map((campaign) => {
                              if (
                                campaign.type ==
                                linkTypeCampaigns.typeCampaignName
                                  .BANNER_ALTERNATIVE
                              ) {
                                return (
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      clickCampaignNameHandler(e, campaign.id);
                                    }}
                                    className="py-2 pr-2 text-right hover border-success border-bottom"
                                  >
                                    <span className="text-dark">
                                      {campaign.name}
                                    </span>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </span>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    whichTypeSelect: state.reportCampaign.which_type_select,
    dateFrom: state.reportCampaign.date_from,
    dateTo: state.reportCampaign.date_to,
    eventDataChart: state.reportCampaign.event_data_chart,
    whichSeparationActive: state.reportCampaign.which_separation_active,
    userPermission: state.main.permissionsUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCampaignReportWithCampaignName: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGN_REPORT_WITH_CAMPAIGN_NAME,
        payload: action,
      });
    },
    getCampaignsReportWithCampaignType: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_REPORT_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
    getCampaignsDataChartWithCampaignName: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_NAME,
        payload: action,
      });
    },
    getCampaignsDataChartWithCampaignType: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
    getCampaignsDataSeparationWithCampaignName: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_NAME,
        payload: action,
      });
    },
    getCampaignsDataSeparationWithCampaignType: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
    getCampaignReportBrowserIP: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGN_REPORT_BROWSER_IP,
        payload: action,
      });
    },
    getCampaignsReportBrowserIP: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_REPORT_BROWSER_IP,
        payload: action,
      });
    },
    resetIsGetDataBrowserFromApi: (action) => {
      dispatch({
        type: reportAction.RESET_IS_GET_DATA_BROWSER_FROM_API,
        payload: action,
      });
    },
    setTypeSeparationDataChart: (action) => {
      dispatch({
        type: reportAction.SET_TYPE_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderReport);
